import { Box, BoxProps } from '@mui/material';

import { TCryptoCurrency } from 'modules/payments/types';

import { getTokenIcon } from './getTokenIcon';

interface ITokenIconProps extends Pick<BoxProps, 'className' | 'sx'> {
  token: TCryptoCurrency;
}

export function TokenIcon({ sx, token, ...restProps }: ITokenIconProps) {
  const tokenIcon = getTokenIcon(token);

  if (!tokenIcon) {
    return null;
  }

  return (
    <Box
      sx={{ width: '1em', height: '1em', ...sx }}
      {...restProps}
      component={tokenIcon}
    />
  );
}
